export const getFieldName = (column, isHistorical) => {
  if (!isHistorical) {
    if (column?.type === 'property') {
      return `ID${column.columnId}_${column.type}_${column.templatePropertyId}_rowAmount`;
    } else {
      return `ID${column.columnId}_${column.type}_${column.measureId}_rowAmount`;
    }
  } else if (column) {
    if (column?.isTotal) {
      return `IDTOTAL_${column.type}_${column.type === 'property' ? column.templatePropertyId : column.measureId}_rowAmount`;
    } else {
      return `ID${column.columnId}_${column.type}_${column.type === 'property' ? column.templatePropertyId : column.measureId}_${column.nodeId}_rowAmount`;
    }
  }
};
